import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { IntegrationGfAdvancedMapData } from './Data';

export interface IntegrationGfAdvancedMapState extends BaseIntegrationState {
  mapKey?: string;
}

export class IntegrationGfAdvancedMapModel extends BaseIntegration<
  IntegrationGfAdvancedMapData,
  IntegrationGfAdvancedMapState
> {
  parse(data: IntegrationGfAdvancedMapData) {
    super.parse(data);
    this.state.mapKey = data.settings?.map_key;
  }

  hasVueComponent() {
    return false;
  }

  authorSignature(): string {
    return 'Ani Mikova';
  }
}
